export const IS_PRD = process.env.NODE_ENV === 'production';
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_STG = (process.env.NODE_ENV as any) === 'staging';
// TODO ポート番号　別で定義
export const BASE_URL = IS_DEV ? 'http://localhost:3100' : process.env.REACT_APP_BASE_URL ?? '';
export const REACT_APP_COMPANY_URL = IS_DEV
  ? 'http://localhost:' + process.env.REACT_APP_COMPANY_PORT
  : process.env.REACT_APP_COMPANY_URL ?? '';
export const REACT_APP_API_BASE_URL = IS_DEV
  ? `http://localhost:${process.env.REACT_APP_SERVER_APP_PORT}`
  : process.env.REACT_APP_API_BASE_URL;
export const REACT_APP_COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
export const REACT_APP_COGNITO_USER_POOL_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_ID_FOR_COMPANY;
export const REACT_APP_COGNITO_USER_POOL_CLIENT_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID_FOR_COMPANY;
export const REACT_APP_CHAT_WEBSOCKET_URL = process.env.REACT_APP_CHAT_WEBSOCKET_URL ?? '';
export const COOKIE_DOMAIN = IS_DEV
  ? 'localhost'
  : process.env.REACT_APP_COOKIE_DOMAIN!;
// COOKIE_DOMAIN移行前は REACT_APP_COMPANY_URL から算出したホスト名をCookieのdomainに使用していたため、
// 移行前にセットされたCookieを削除する際はこの値を旧ドメインとして使用する
export const LEGACY_COOKIE_DOMAIN = REACT_APP_COMPANY_URL.replace(/^https:\/\//, '');

export const LEARNER_V2_URL = IS_DEV
  ? 'http://localhost:3005'
  : process.env.REACT_APP_LEARNER_URL ?? '';

export const URL_PRIVACY = process.env.REACT_APP_BASE_URL + '/privacy';
export const URL_TERMS = process.env.REACT_APP_BASE_URL + '/terms';
export const URL_TRANSACTIONS = process.env.REACT_APP_BASE_URL + '/transactions';

export const DELETE_FLG = {
  // 削除
  DELETED: '1',
  // 未削除
  AVAILABLE: '0',
} as const;
export type DELETE_FLG = (typeof DELETE_FLG)[keyof typeof DELETE_FLG];
export const STOP_FLG = {
  // 停止
  STOPPED: '1',
  // 未停止
  AVAILABLE: '0',
} as const;
export type STOP_FLG = (typeof STOP_FLG)[keyof typeof STOP_FLG];
// 承認フラグ
export const APPROVAL_FLG = {
  // 承認
  APPROVED: 1,
  // 承認待ち
  WAIT: 0,
} as const;
export type APPROVAL_FLG = (typeof APPROVAL_FLG)[keyof typeof APPROVAL_FLG];
// キャンセルフラグ
export const CANCEL_FLG = {
  // キャンセル済み
  CANCELED_LEARNER: 4,
  CANCELED_MANAGER: 3,
  CANCELED_TEACHER: 2,
  CANCELED_COMPANY: 1,
  // キャンセルなし
  NONE: 0,
} as const;
export type CANCEL_FLG = (typeof CANCEL_FLG)[keyof typeof CANCEL_FLG];

export const RELEASE_FLG = {
  // 公開
  PUBLIC: '1',
  // 非公開
  PRIVATE: '0',
} as const;
export type RELEASE_FLG = (typeof RELEASE_FLG)[keyof typeof RELEASE_FLG];

export const SEARCH_STATUS = {
  // 有効
  ENABLE: '1',
  // 無効
  DISABLE: '2',
} as const;
export type SEARCH_STATUS = (typeof SEARCH_STATUS)[keyof typeof SEARCH_STATUS];

export type QUERY_RESULT = number & { QUERY_RESULT: never };
export const MESSAGE = {
  NO_ERROR: 'NO_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  NOT_AUTHORIZED_USER_ACCESS: 'NOT_AUTHORIZED_USER_ACCESS',
} as const;
export type MESSAGE = (typeof MESSAGE)[keyof typeof MESSAGE] | QUERY_RESULT;
export const MAX_EMAIL_CHARS = 3000;

//Total count for season, chapter, summary
export const TOTAL_COUNT = {
  /** シーン（旧CHAPTER） */
  SCENE: 10,
  /** エピソードまとめ */
  EPISODE_SUMMARY: 12,
  /** シーズンまとめ */
  SEASON_SUMMARY: 50,
};

//お試しプラン
export const TRIAL_BILLED_AMOUNT = 0;
export const S3_PATH = 'https://sun-resource-tokyo.s3-ap-northeast-1.amazonaws.com/';
export const KURASHI_STUDY_API_PATH = 'https://api-manager.kurashi-study.net/cms/';
// NOTE マジックナンバー対処用
export const STORY_EPISODE_ID_SECTION_INDEX = {
  'Ep.x-1': 0,
  'Ep.x-2': 1,
  'Ep.x-3': 2,
  'Ep.x summary': 3,
} as const;
export const FEED_BACK_STATUS = {
  COMPLETED: '記入済み',
  BLANK: '未記入',
} as const;
export const SESSION_TYPE = {
  STORY: 1,
  DORILL: 2,
} as const;
export type SESSION_TYPE = (typeof SESSION_TYPE)[keyof typeof SESSION_TYPE];
export type SESSION_TYPE_KEY = keyof typeof SESSION_TYPE;
export const SESSION_TYPE_REVERSE: Record<SESSION_TYPE, SESSION_TYPE_KEY> = {
  1: 'STORY',
  2: 'DORILL',
};
export const CANCEL_STATUS = {
  /** キャンセルなし */
  NOT_CANCEL: '0',
  /** キャンセル（学習者・リスケ対象） */
  CANCELLED_LEARNER_RESCHEDULE: '1',
  /** キャンセル（学習者・リスケ対象外） */
  CANCELLED_LEARNER_NOT_RESCHEDULE: '2',
  /** キャンセル（企業・リスケ対象） */
  CANCELLED_COMPANY_RESCHEDULE: '3',
  /** キャンセル（企業・リスケ対象外） */
  CANCELLED_COMPANY_NOT_RESCHEDULE: '4',
  /** キャンセル（SUN管理者・リスケ対象） */
  CANCELLED_ADMIN_RESCHEDULE: '5',
  /** キャンセル（SUN管理者・リスケ対象外） */
  CANCELLED_ADMIN_NOT_RESCHEDULE: '6',
} as const;
export type CANCEL_STATUS_TYPE = (typeof CANCEL_STATUS)[keyof typeof CANCEL_STATUS];

export const PARTICIPATION_STATUS = {
  /** 参加予定 */
  WILL_PARTICIPATE: '0',
  /** 参加 */
  PARTICIPATED: '1',
  /** 不参加 */
  NOT_PARTICIPATED: '2',
  /** キャンセル */
  CANCELLED: '3',
} as const;
export type PARTICIPATION_STATUS_TYPE =
  (typeof PARTICIPATION_STATUS)[keyof typeof PARTICIPATION_STATUS];
